import { Component, getAssetPath, h } from '@stencil/core';
import state from '../../store';

@Component({
  tag: 'hemfixarna-cart',
  shadow: false,
})
export class HemfixarnaCart {
  render() {
    const back = getAssetPath(`./assets/back.svg`);

    return (
      <div class="hemfixarna_cart">
        <div class="hemfixarna_cart--left">
          <h2>
            {state.checkoutStep === 2 && !state.checkoutEdit && (
              <button
                onClick={() => {
                  state.checkoutStep = 1;
                }}
              >
                <img width={24} src={back} alt="back arrow" />
              </button>
            )}
            Din bokning
          </h2>
          <hemfixarna-orderrows />
        </div>
        <div class="hemfixarna_cart--right">
          <h2>
            {state.checkoutStep === 2 && !state.checkoutEdit && (
              <button
                onClick={() => {
                  state.checkoutStep = 1;
                }}
              >
                <img width={24} src={back} alt="back arrow" />
              </button>
            )}
            Dina uppgifter
          </h2>
          <hemfixarna-checkout />
          <hemfixarna-info />
        </div>
      </div>
    );
  }
}
